import { render, staticRenderFns } from "./MaterialSourceEdit.vue?vue&type=template&id=4059fa22&scoped=true&"
import script from "./MaterialSourceEdit.vue?vue&type=script&lang=js&"
export * from "./MaterialSourceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4059fa22",
  null
  
)

export default component.exports